
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
  },

  items: {
    padding: '1%',
    marginLeft: '30px'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
  },

  item_body: {
    padding: '6px ',
  },

  main_header: {
    padding: '1%',
    fontSize: '30px',
    textAlign:'center',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },
  heading_div:{
    fontSize:'14px',
    fontWeight:'bold',
  },
  
  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
    fontSize:'20px',
  },
  button_view: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '2%',
    fontSize:'22px',
  },
  input_button:{
    backgroundColor: '#21A6DB',
    color:'white',
    borderRadius: '6px',
    marginBottom:'4px',
    marginTop:'4px',
  },
  delete_button:{
    backgroundColor: 'red',
    color:'white',
    borderRadius: '6px',
    marginBottom:'4px',
    marginTop:'4px',
  },
  body_div:{
    fontSize:'18px',
  },

  input: {
    width: '40%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionStructure/style.js